var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletada(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384.51 373.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #05883b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.28,122.09c11.59-3.53,22.29,6.71,14.67,16.84l-114.7,116c-5.48,2.39-8.48,2.64-13.72-.41-12.34-7.19-30.38-40.14-43.38-50.2-4.65-9.68,4.51-20.05,14.74-17,8.56,2.56,30.61,39.78,37.16,38.64l105.22-103.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.92,318.85c-66.93,0-121.38-55.07-121.38-122.76s54.45-122.76,121.38-122.76c27.06,0,52.67,8.81,74.06,25.49l-16.6,21.29c-16.6-12.94-36.46-19.78-57.45-19.78-52.04,0-94.38,42.96-94.38,95.76s42.34,95.76,94.38,95.76,94.38-42.96,94.38-95.76c0-9.74-1.43-19.35-4.26-28.55l25.81-7.93c3.62,11.78,5.45,24.05,5.45,36.48,0,67.69-54.45,122.76-121.38,122.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletada);
export default __webpack_public_path__ + "static/media/completada.3c501666a839a2af546929c4eeb0246b.svg";
export { ForwardRef as ReactComponent };